import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SelectWidget } from '@plone/volto/components';
import QuerystringWidget from '@plone/volto/components/manage/Widgets/QuerystringWidget';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  Source: {
    id: 'Source',
    defaultMessage: 'Source',
  },
  whichEvents: {
    id: 'Which Events',
    defaultMessage: 'Quali eventi vuoi mostrare subito?',
  },
});

const Sidebar = (props) => {
  const intl = useIntl();
  if (!props.data.whichEvents) {
    props.onChangeBlock(props.block, {
      ...props.data,
      whichEvents: 'next', //di default vengono mostrati i prossimi eventi
    });
  }

  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage
            id="SearchEventsBlock"
            defaultMessage="Ricerca eventi"
          />
        </h2>
      </header>
      <Segment className="form sidebar-listing-data">
        <SelectWidget
          id="whichEvents"
          title={intl.formatMessage(messages.whichEvents)}
          required={false}
          description="Se impostato, il blocco preimposterà le date per mostrare gli eventi che corrispondono al valore selezionato"
          value={props.data.whichEvents}
          onChange={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          choices={[
            ['none', 'Nessuno'],
            ['all', 'Tutti'],
            ['next', 'Prossimi eventi'],
            ['today', 'Del giorno'],
            ['weekend', 'Del weekend'],
            ['month', 'Del mese'],
          ]}
        />

        <QuerystringWidget
          id="source"
          title={intl.formatMessage(messages.Source)}
          required={false}
          value={{ ...props.data, query: props.data.query ?? [] }}
          onChange={(name, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              query: value.query,
              b_size: Number(value.b_size) ?? undefined, // default batch size
              limit: Number(value.limit) ?? undefined, // optional limit
              sort_on: value.sort_on,
              sort_order_boolean: value.sort_order_boolean,
            });
          }}
        />
      </Segment>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default injectIntl(Sidebar);
